import { create } from "zustand";

// Tracks which listings this browser has opened for a detail view, so the
// table/card views can visually distinguish already-seen listings. There's
// no per-user "viewed" flag from the API (only a global view counter), so
// this is purely local, persisted to localStorage.
const STORAGE_KEY = "emlak_viewed_properties_v1";
const MAX_ENTRIES = 1000; // cap so localStorage doesn't grow unbounded

const loadViewed = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return raw && typeof raw === "object" ? raw : {};
  } catch {
    return {};
  }
};

export const useViewed = create((set, get) => ({
  viewed: loadViewed(),

  isViewed: (idProperty) => !!get().viewed[idProperty],

  markViewed: (idProperty) => {
    if (!idProperty || get().viewed[idProperty]) return;
    set((s) => {
      const entries = Object.entries(s.viewed);
      const trimmed = entries.length >= MAX_ENTRIES
        ? entries.sort((a, b) => a[1] - b[1]).slice(entries.length - MAX_ENTRIES + 1)
        : entries;
      const next = { ...Object.fromEntries(trimmed), [idProperty]: Date.now() };
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch { /* storage unavailable — keep viewed state in memory only */ }
      return { viewed: next };
    });
  },
}));
